<!-- eslint-disable max-len -->
<template>
  <div
    :class="{
      'object-container-automation' : !onProperties,
      'object-active' : blockActive
    }"
    class="position-relative"
    style="cursor:default"
    @mouseover="pauseZoom"
    @mouseleave="resumeZoom"
  >
    <!-- Disable Block -->
    <div
      v-if="onProperties"
      class="toggle-disable-block"
    >
      <j-switch v-model="disable_block" />

      <!-- Tooltip -->
      <div class="tooltip-toggle-disable">
        {{ disable_block ? 'Disable' : 'Enable' }} this block
      </div>
    </div>

    <template v-if="!onProperties">
      <img
        :src="require('@/assets/automation/trigger.svg')"
        width="20"
        height="20"
        class="m__r--5">
      <span class="title-automation m__r--5">TRIGGER</span>
      <span class="id-block-automation">{{ data_trigger.id ? `#${data_trigger.id}` : '' }}</span>
    </template>
    <img
      v-if="!onProperties"
      :src="require('@/assets/automation/config.svg')"
      width="20"
      height="20"
      class="pull-right cursor-pointer"
      @click="showProperties">

    <div v-if="onProperties">
      <div class="sub-header-properties-wrap">
        <img
          :src="require(`@/assets/automation/${selectedObject.img}.svg`)"
          width="25">
        <div class="text-object"> {{ selectedObject.title }} </div>
      </div>

      <div class="section-border mb-3">
        <b-form-group :class="{'error-input' : $v.name_automation.$error}">
          <label for="name"> Name </label>
          <j-input
            id="name"
            v-model="$v.name_automation.$model"
            :error-required="$v.name_automation.$error"
            placeholder="Type visual programming name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.description.$error}">
          <label for="description"> Description </label>
          <j-textarea
            v-model="$v.description.$model"
            :error-required="$v.description.$error"
            :max-length="255"
            placeholder="Type visual programming description"
          />
        </b-form-group>

        <div v-if="data_trigger.object === 'form'">
          <b-row>
            <b-col md="12">
              <b-form-group :class="{'error-input' : $v.data_trigger.table_group.$error}">
                <label> Table Group </label>
                <j-single-select
                  v-model="$v.data_trigger.table_group.$model"
                  :error-required="$v.data_trigger.table_group.$error"
                  :options="tableGroupOptions"
                  placeholder="Select Table Group"
                  value-format="object"
                  label="name"/>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group :class="{'error-input' : $v.data_trigger.form.$error}">
                <label> Table </label>
                <j-single-select
                  v-model="$v.data_trigger.form.$model"
                  :error-required="$v.data_trigger.form.$error"
                  :disabled="!data_trigger.table_group"
                  :options="tableOptions"
                  :placeholder="'Select Table'"
                  value-format="object"
                  label="name"/>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group :class="{'error-input' : $v.data_trigger.event.$error}">
                <label> Event </label>
                <j-single-select
                  v-model="$v.data_trigger.event.$model"
                  :error-required="$v.data_trigger.event.$error"
                  :options="eventOptions"
                  placeholder="Event"/>
              </b-form-group>
            </b-col>
          </b-row>
          <label
            v-if="data_trigger.form ? data_trigger.form.is_share_device_info : false"
            style="color: #42a5ce">
            Allow to share device info</label>
        </div>

        <div v-if="data_trigger.object === 'scheduller'">
          <b-row>
            <b-col md="4">
              <b-form-group :class="{'error-input' : $v.data_trigger.every_int.$error}">
                <label> Every </label>
                <j-input
                  v-model="$v.data_trigger.every_int.$model"
                  :max-length="255"
                  type="number"/>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :class="{'error-input' : $v.data_trigger.every.$error}">
                <label> Every </label>
                <j-single-select
                  v-model="$v.data_trigger.every.$model"
                  :error-required="$v.data_trigger.every.$error"
                  :options="everyOptions"
                  placeholder="Select"/>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :class="{'error-input' : $v.data_trigger.at.$error}">
                <label> At </label>
                <j-clockpicker
                  v-model="$v.data_trigger.at.$model"
                  :error-required="$v.data_trigger.at.$error"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div v-if="data_trigger.object === 'event'">
          <b-row>
            <b-col md="12">
              <b-form-group :class="{'error-input' : $v.data_trigger.event_name.$error}">
                <label> Event Name </label>
                <j-single-select
                  v-model="$v.data_trigger.event_name.$model"
                  :error-required="$v.data_trigger.event_name.$error"
                  :options="optionEventName"
                  placeholder="Select"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div v-if="data_trigger.object === 'function'">
          <b-row>
            <b-col md="12">
              <b-form-group :class="{'error-input' : $v.data_trigger.function_name.$error}">
                <label> Function Name </label>
                <j-input
                  v-model="$v.data_trigger.function_name.$model"
                  :error-required="$v.data_trigger.function_name.$error"
                  :max-length="255"
                  placeholder="Only lowercase characters and underscore '_' are allowed, ex: name_function"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div v-if="data_trigger.object === 'job'">
          <b-row>
            <b-col md="12">
              <b-form-group :class="{'error-input' : $v.data_trigger.job_name.$error}">
                <label> Job Name </label>
                <j-input
                  v-model="$v.data_trigger.job_name.$model"
                  :error-required="$v.data_trigger.job_name.$error"
                  :max-length="255"
                  placeholder="Only lowercase characters and underscore '_' are allowed, ex: name_job"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div v-if="data_trigger.object === 'dedicated_job'">
          <b-row>
            <b-col md="12">
              <b-form-group :class="{'error-input' : $v.data_trigger.dedicated_job_name.$error}">
                <label> Dedicated Job Name </label>
                <j-input
                  v-model="$v.data_trigger.dedicated_job_name.$model"
                  :error-required="$v.data_trigger.dedicated_job_name.$error"
                  :max-length="255"
                  placeholder="Only lowercase characters and underscore '_' are allowed, ex: name_dedicated_job"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div
          v-if="data_trigger.object === 'api' ||
            data_trigger.object === 'api_v2' ||
            data_trigger.object === 'webhook' ||
          data_trigger.object === 'webhook_v2'">
          <b-form-group :class="{'error-input' : $v.data_trigger.url.$error}">
            <div class="d-flex m__t--10">
              <div class="label-url-api"> Url </div>
              <div class="base-url-api">{{ url }}</div>
            </div>

            <div class="container-value-api">
              <div
                class="method cursor-pointer"
                @click="openListMethod = !openListMethod">{{ data_trigger.method }}</div>
              <i
                class="fa fa-chevron-down cursor-pointer"
                @click="openListMethod = !openListMethod"
              />
              <div
                v-if="openListMethod"
                class="selections-method">
                <div
                  v-for="option in methodOptions"
                  :key="option.id"
                  class="option"
                  @click="data_trigger.method = option.id; openListMethod = false"
                >
                  <span>{{ option.text }}</span>
                </div>
              </div>
              <j-input
                v-model="$v.data_trigger.url.$model"
                :max-length="255"
              />
              <i
                class="fa fa-clone copy-url"
                @click="copyToClipboard"
              />
            </div>
          </b-form-group>
        </div>
      </div>

      <div class="section-border mt-3 mb-4">
        <p class="title-section">Configuration</p>

        <!-- Run History -->
        <div class="config-toggle">
          <div class="wrap-config-toggle-desc">
            <p class="title-config-toggle">Disable Run History</p>
            <p class="desc-config-toggle">
              To improve performance, the result of the all blocks will be disabled in the run history. Container variables can still be used to store block execution results.
            </p>
          </div>
          <j-switch v-model="disable_run_history" />
        </div>

        <!-- Rate Limits -->
        <div
          v-if="data_trigger.object === 'api_v2'"
          class="config-toggle d-block">
          <div class="d-flex justify-content-between">
            <div class="wrap-config-toggle-desc">
              <p class="title-config-toggle">Rate Limits</p>
              <p class="desc-config-toggle">
                Rate limit is a restriction on the number of requests within a specific time period to prevent resource abuse and maintain system performance.
              </p>
            </div>
            <j-switch v-model="data_trigger.is_rate_limits" />
          </div>
          <div
            v-if="data_trigger.is_rate_limits"
            class="container-value-api container-value-api__maximum">
            <div class="label">Maximum Request</div>
            <j-input
              v-model="data_trigger.rate_limits"
              type="number"
              class="input-maximum"
            />
            <div class="base-url-api tag-label">per seconds</div>
          </div>
        </div>

        <!-- Max Length Char Payload Limits -->
        <!-- <div
          v-if="data_trigger.object === 'api_v2'"
          class="config-toggle d-block">
          <div class="d-flex justify-content-between">
            <div class="wrap-config-toggle-desc">
              <p class="title-config-toggle">Max Length Char Payload Limits</p>
              <p class="desc-config-toggle">
                Char payload limit is a restriction length of requests
              </p>
            </div>
            <j-switch v-model="data_trigger.is_max_length_limits" />
          </div>
          <div
            v-if="data_trigger.is_max_length_limits"
            class="container-value-api container-value-api__maximum">
            <div class="label">Maximum Char</div>
            <j-input
              v-model="data_trigger.max_length_limits"
              :max-length="255"
              class="input-maximum"
            />
            <div class="base-url-api tag-label">per request</div>
          </div>
        </div> -->

        <!-- Specific Run Service -->
        <div
          v-if="showSwitcherService"
          class="config-toggle">
          <div class="wrap-config-toggle-desc">
            <p class="title-config-toggle">Specific Run Service</p>
            <div class="container-value-api container-value-api__maximum">
              <div class="label">Service</div>
              <div
                class="label-border-left cursor-pointer"
                @click="openListSerive = !openListSerive">{{ nocodeServiceTarget }}</div>
              <i
                class="fa fa-chevron-down cursor-pointer"
                @click="openListSerive = !openListSerive"
              />
              <div
                v-if="openListSerive"
                class="selections-method selections-service">
                <div
                  v-for="option in serviceOptions"
                  :key="option.id"
                  class="option"
                  @click="nocodeServiceTarget = option; openListSerive = false"
                >
                  <span>{{ option }}</span>
                </div>
              </div>
            </div>
            <p class="desc-config-toggle m__t--5">
              For running process on specific service
            </p>
          </div>
        </div>
      </div>

      <hr>
      <span class="title-automation">Container Variable</span>
      <b-form-group :class="{'error-input' : $v.data_trigger.variable_name.$error}">
        <label> Request </label>
        <j-input
          v-model="$v.data_trigger.variable_name.$model"
          :error-required="$v.data_trigger.variable_name.$error"
          :max-length="255"
          placeholder="Variable Name"/>
      </b-form-group>

      <div
        v-if="data_trigger.object === 'api' ||
          data_trigger.object === 'api_v2' ||
          data_trigger.object === 'webhook' ||
          data_trigger.object === 'webhook_v2' ||
        data_trigger.object === 'function'">
        <b-form-group :class="{'error-input' : $v.data_trigger.variable_response.$error}">
          <label> Response </label>
          <j-input
            v-model="$v.data_trigger.variable_response.$model"
            :error-required="$v.data_trigger.variable_response.$error"
            :max-length="255"
            placeholder="Variable Name"/>
        </b-form-group>
      </div>
    </div>
    <div v-else>
      <b-row
        v-if="showContainer"
        class="m__t--10 m__b--10">
        <b-col
          md="2"
          class="p__r--1">
          <img
            v-if="dataEdit.trigger.type === 'form'"
            :src="require('@/assets/automation/data_manager.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-else-if="dataEdit.trigger.type === 'event'"
            :src="require('@/assets/automation/event.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-else-if="dataEdit.trigger.type === 'function'"
            :src="require('@/assets/automation/function.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-else-if="dataEdit.trigger.type === 'job' ||
            dataEdit.trigger.type === 'dedicated_job'"
            :src="require('@/assets/automation/job.svg')"
            width="35"
            height="35"
            class="m__t--5">
          <img
            v-else
            :src="require('@/assets/automation/api.svg')"
            width="35"
            height="35">
        </b-col>
        <b-col
          v-if="dataEdit.trigger.type === 'form'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form ellipsis m__l--10">
            {{ data_trigger.form ? data_trigger.form.name : '' }}
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ eventLabel }}
          </div>
        </b-col>
        <b-col
          v-else-if="dataEdit.trigger.type === 'event'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            Event
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ data_trigger.event_name }}
          </div>
        </b-col>
        <b-col
          v-else-if="dataEdit.trigger.type === 'function'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            Function
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ data_trigger.function_name }}
          </div>
        </b-col>
        <b-col
          v-else-if="dataEdit.trigger.type === 'job'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            Job
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ data_trigger.job_name }}
          </div>
        </b-col>
        <b-col
          v-else-if="dataEdit.trigger.type === 'dedicated_job'"
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            Dedicated Job
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ data_trigger.dedicated_job_name }}
          </div>
        </b-col>
        <b-col
          v-else
          md="10"
          class="p__l--1">
          <div class="trigger__label-form m__l--10">
            {{ dataEdit.trigger.type.includes('webhook') ? 'Webhook' : 'API' }}
            <span
              v-if="data_trigger.method"
              class="trigger__label-api">{{ data_trigger.method.toUpperCase() }}</span>
          </div>
          <div class="trigger__label-event ellipsis m__l--10">
            {{ url }}{{ data_trigger.url }}
          </div>
        </b-col>
      </b-row>
      <div
        v-if="showContainer"
        class="trigger__label-variable ellipsis">
        <img
          :src="require('@/assets/automation/variable.png')"
          width="20"
          height="20"
          class="m__r--10">
        {{ data_trigger.variable_name }}
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { required, requiredIf } from 'vuelidate/lib/validators';
import { mapActions, mapMutations, mapState } from 'vuex';
import jSwitch from '@/components/inputs/jSwitch';

// Mixins
import jMixPanZoom from '@/mixins/visual-programming/jMixPanZoom';

import jwtDecode from 'jwt-decode';

export default {
  name: 'JAutomationTrigger',
  components: {
    jSwitch,
  },
  mixins: [jMixPanZoom],
  props: {
    dataEdit: {
      type: Object,
      default: () => {},
    },
    onProperties: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data_trigger: {
        id: '',
        object: null,
        table_group: null,
        form: null,
        event: null,
        variable_name: '',

        every_int: 0,
        every: null,
        at: '',

        method: null,
        url: '',
        content_type: null,
        header: '',
        variable_response: '',
        event_name: null,
        function_name: null,
        job_name: null,
        dedicated_job_name: null,

        is_rate_limits: false,
        rate_limits: 0,
        is_max_length_limits: false,
        max_length_limits: 0,
      },

      blockError: false,
      blockActive: false,
      showContainer: false,

      tableOptions: [],
      optionEventName: [],
      tableGroupOptions: [],
      finishSetDataTableGroup: false,

      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      disable_block: false,
      name_automation: '',
      description: '',
      disable_run_history: false,
      openListMethod: false,
      nocodeServiceOrigin: 'nocode-service-0',
      nocodeServiceTarget: 'nocode-service-0',
      serviceOptions: [],
      openListSerive: false,

      objectOptions: [
        {
          id: 'form',
          text: 'Data Manager',
        },
        {
          id: 'webhook',
          text: 'Webhook',
        },
        {
          id: 'webhook_v2',
          text: 'Webhook',
        },
        {
          id: 'api',
          text: 'API',
        },
        {
          id: 'api_v2',
          text: 'API',
        },
        {
          id: 'event',
          text: 'Event',
        },
      ],
      eventOptions: [
        {
          id: 'record_created',
          text: 'Record Created',
        },
        {
          id: 'record_updated',
          text: 'Record Updated',
        },
        {
          id: 'record_deleted',
          text: 'Record Deleted',
        },
        {
          id: 'record_approved',
          text: 'Record Approved',
        },
        {
          id: 'record_rejected',
          text: 'Record Rejected',
        },
        {
          id: 'record_submitted',
          text: 'Record Submitted',
        },
        {
          id: 'record_exported',
          text: 'Record Exported',
        },
        {
          id: 'record_closed',
          text: 'Record Closed',
        },
      ],
      everyOptions: [
        {
          id: 'minutes',
          text: 'Minutes',
        },
        {
          id: 'hours',
          text: 'Hours',
        },
        {
          id: 'daily',
          text: 'Daily',
        },
        {
          id: 'weekly',
          text: 'Weekly',
        },
        {
          id: 'monthly',
          text: 'Monthly',
        },
        {
          id: 'anual',
          text: 'Anual',
        },
      ],
      methodOptions: [
        {
          id: 'post',
          text: 'POST',
        },
        {
          id: 'get',
          text: 'GET',
        },
        {
          id: 'delete',
          text: 'DELETE',
        },
      ],
      contentTypeOptions: [
        {
          id: 'json',
          text: 'JSON',
        },
      ],
    };
  },
  computed: {
    ...mapState('jStoreAutomation', ['propertiesOpened']),
    ...mapState('jStoreSetting', ['user_company_setting']),

    eventLabel() {
      const event = this.eventOptions.find(f => f.id === this.dataEdit.trigger.form.event);
      return event ? event.text : '';
    },

    url() {
      const type = this.data_trigger.object;

      if (type === 'api_v2') return `${process.env.URL_API_V2}${this.session.user.company_id}/`;
      else if (type === 'webhook_v2') return `${process.env.URL_WEBHOOK_V2}${this.session.user.company_id}/`;
      return `${process.env.GATE_URL}nocode/${type}/`;
    },

    selectedObject() {
      switch (this.data_trigger.object) {
        case 'form':
          return {
            img: 'data_manager',
            title: 'Data Manager',
          };
        case 'event':
          return {
            img: 'event',
            title: 'Event Listener',
          };
        case 'function':
          return {
            img: 'function',
            title: 'Function',
          };
        case 'job':
          return {
            img: 'job',
            title: 'Job',
          };
        case 'dedicated_job':
          return {
            img: 'job',
            title: 'Dedicated Job',
          };
        case 'api':
          return {
            img: 'api',
            title: 'API',
          };
        case 'api_v2':
          return {
            img: 'api',
            title: 'API',
          };
        default:
          return {
            img: 'api',
            title: 'Webhook',
          };
      }
    },

    showSwitcherService() {
      return this.user_company_setting && this.user_company_setting.nocode_switcher &&
      (this.data_trigger.object === 'webhook_v2' || this.data_trigger.object === 'api_v2' || this.data_trigger.object === 'dedicated_job');
    },
  },
  watch: {
    dataEdit() {
      this.setValueOnProperties();
    },

    propertiesOpened(val) {
      if (!val) this.blockActive = false;
    },

    // eslint-disable-next-line
    'data_trigger.function_name': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.data_trigger.function_name =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'data_trigger.job_name': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.data_trigger.job_name =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'data_trigger.dedicated_job_name': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.data_trigger.dedicated_job_name =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line func-names
    'data_trigger.variable_name': function (val) {
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.data_trigger.variable_name = val.replace(regexSymbol, '').replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line func-names
    'data_trigger.variable_response': function (val) {
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.data_trigger.variable_response = val.replace(regexSymbol, '').replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'data_trigger.table_group': function (val) {
      if (val) {
        const reqTable = {
          tablegroup_id: val.id,
          search: '',
        };
        this.getListTableByGroupV2(reqTable).then((res) => {
          if (this.finishSetDataTableGroup) this.data_trigger.form = null;
          if (!res.error) this.tableOptions = res.data || [];
          setTimeout(() => { this.$v.data_trigger.$reset(); }, 10);
        });
      }
    },
  },
  created() {
    this.loadOptionsEventName();
    this.setValueOnProperties();
    this.getListGroupTable();
    this.getListServiceOptions();
  },
  methods: {
    ...mapActions('jStoreAutomation', ['findForm', 'getListEventNameList']),
    ...mapActions('jStoreForm', ['getListDataGroupByCompanyId', 'getListTableByGroupV2', 'getListServiceSwitcher', 'actionServiceSwitcher']),
    ...mapMutations('jStoreAutomation', ['setPropertiesOpened']),

    setValueOnProperties() {
      const newVal = this.dataEdit;
      this.data_trigger.id = newVal.trigger.id;
      this.data_trigger.object = newVal.trigger.type;
      this.data_trigger.variable_name = newVal.trigger.container_variable;
      this.blockError = false;
      this.disable_block = newVal.is_active;
      this.name_automation = newVal.name;
      this.description = newVal.description;
      this.disable_run_history = newVal.disable_run_history;

      if (newVal.trigger.type === 'form') {
        const reqData = {
          form_data_id: newVal.trigger.form.form_data_id,
        };
        if (newVal.trigger.form.form_data_id) {
          this.findForm(reqData).then((res) => {
            const dataForm = res.data;
            dataForm.label = dataForm.name;
            this.data_trigger.form = dataForm;
            this.showContainer = true;

            if (this.tableGroupOptions.length > 0) {
              const findTableGroup = this.tableGroupOptions.find(f => f.id === newVal.trigger.form.tablegroup_id);
              this.data_trigger.table_group = findTableGroup || null;

              if (!findTableGroup && this.data_trigger.form) {
                if (this.data_trigger.form.tablegroup_id) {
                  const findTableGroupExist = this.tableGroupOptions.find(f => f.id === this.data_trigger.form.tablegroup_id);
                  this.data_trigger.table_group = findTableGroupExist || null;
                } else {
                  const findTableGroupLegacy = this.tableGroupOptions.find(f => f.id === 'legacy');
                  this.data_trigger.table_group = findTableGroupLegacy;
                }
              } else if (!findTableGroup && !this.data_trigger.form) {
                const findTableGroupLegacy = this.tableGroupOptions.find(f => f.id === 'legacy');
                this.data_trigger.table_group = findTableGroupLegacy;
              }
            }
          });
        }

        this.data_trigger.event = newVal.trigger.form.event;
      } else if (newVal.trigger.type === 'scheduller') {
        this.data_trigger.every_int = newVal.trigger.scheduler.every;
        this.data_trigger.every = newVal.trigger.scheduler.type;
        this.data_trigger.at = newVal.trigger.scheduler.at;
        this.showContainer = true;
      } else if (newVal.trigger.type === 'webhook') {
        this.data_trigger.method = newVal.trigger.webhook.method;
        this.data_trigger.url = newVal.trigger.webhook.url;
        this.data_trigger.variable_response = newVal.trigger.container_response;
        this.showContainer = true;
      } else if (newVal.trigger.type === 'webhook_v2') {
        this.data_trigger.method = newVal.trigger.webhook_v2.method;
        this.data_trigger.url = newVal.trigger.webhook_v2.url.replace(`${this.session.user.company_id}/`, '');
        this.data_trigger.variable_response = newVal.trigger.container_response;
        this.showContainer = true;
      } else if (newVal.trigger.type === 'api') {
        this.data_trigger.method = newVal.trigger.api.method;
        this.data_trigger.url = newVal.trigger.api.url;
        this.data_trigger.variable_response = newVal.trigger.container_response;
        this.showContainer = true;
      } else if (newVal.trigger.type === 'api_v2') {
        this.data_trigger.method = newVal.trigger.api_v2.method;
        this.data_trigger.url = newVal.trigger.api_v2.url.replace(`${this.session.user.company_id}/`, '');
        this.data_trigger.variable_response = newVal.trigger.container_response;
        this.data_trigger.is_rate_limits = newVal.trigger.api_v2.rate_limit > 0;
        this.data_trigger.rate_limits = newVal.trigger.api_v2.rate_limit || 0;
        // this.data_trigger.is_max_length_limits = newVal.trigger.api_v2.max_length_char_payload > 0;
        // this.data_trigger.max_length_limits = newVal.trigger.api_v2.max_length_char_payload || 0;
        this.showContainer = true;
      } else if (newVal.trigger.type === 'event') {
        this.data_trigger.event_name = newVal.trigger.event.name;
        this.showContainer = true;
      } else if (newVal.trigger.type === 'function') {
        this.data_trigger.function_name = newVal.trigger.function ? newVal.trigger.function.name : null;
        this.data_trigger.variable_response = newVal.trigger.container_response;
        this.showContainer = true;
      } else if (newVal.trigger.type === 'job') {
        this.data_trigger.job_name = newVal.trigger.job ? newVal.trigger.job.name : null;
        this.showContainer = true;
      } else if (newVal.trigger.type === 'dedicated_job') {
        this.data_trigger.dedicated_job_name = newVal.trigger.dedicated_job ? newVal.trigger.dedicated_job.name : null;
        this.showContainer = true;
      }
    },

    getListGroupTable() {
      this.getListDataGroupByCompanyId().then((res) => {
        if (!res.error) {
          this.tableGroupOptions = res.data || [];

          if (this.dataEdit && this.dataEdit.trigger.type === 'form') {
            const findTableGroup = res.data.find(f => f.id === this.dataEdit.trigger.form.tablegroup_id);
            this.data_trigger.table_group = findTableGroup || null;

            if (!findTableGroup && this.data_trigger.form) {
              if (this.data_trigger.form.tablegroup_id) {
                const findTableGroupExist = res.data.find(f => f.id === this.data_trigger.form.tablegroup_id);
                this.data_trigger.table_group = findTableGroupExist || null;
              } else {
                const findTableGroupLegacy = res.data.find(f => f.id === 'legacy');
                this.data_trigger.table_group = findTableGroupLegacy;
              }
            } else if (!findTableGroup && !this.data_trigger.form) {
              const findTableGroupLegacy = res.data.find(f => f.id === 'legacy');
              this.data_trigger.table_group = findTableGroupLegacy;
            }

            setTimeout(() => {
              this.finishSetDataTableGroup = true;
            }, 1000);
          }
        }
      });
    },

    getListServiceOptions() {
      if (this.showSwitcherService) {
        this.getListServiceSwitcher().then((res) => {
          if (!res.error) this.serviceOptions = res.data;
        });

        this.actionServiceSwitcher({
          action: 'getAutomationSwitcher',
          param: { automation_id: this.dataEdit.id },
        }).then((res) => {
          if (!res.error) {
            this.nocodeServiceOrigin = res.data.nocode_service_target;
            this.nocodeServiceTarget = res.data.nocode_service_target;
          }
        });
      }
    },

    loadOptionsEventName() {
      const options = [];
      this.getListEventNameList().then((data) => {
        data.data.forEach((e) => {
          options.push({ id: e, text: e });
        });
      });
      this.optionEventName = options;
    },

    validateData() {
      this.$v.data_trigger.$touch();
      return this.$v.data_trigger.$error;
    },

    getData() {
      return new Promise((resolve, reject) => {
        if (!this.validateData()) {
          let dataForm = {};
          if (this.data_trigger.object === 'form') {
            dataForm = {
              event: this.data_trigger.event,
              form_data_id: this.data_trigger.form.id,
              tablegroup_id: this.data_trigger.table_group.id,
            };
          }
          let dataSceduller = {};
          if (this.data_trigger.object === 'scheduller') {
            dataSceduller = {
              every: this.data_trigger.every_int,
              type: this.data_trigger.every,
              at: this.data_trigger.at,
            };
          }
          let dataWebhook = {};
          if (this.data_trigger.object === 'webhook' || this.data_trigger.object === 'webhook_v2') {
            dataWebhook = {
              method: this.data_trigger.method,
              url: this.data_trigger.url,
            };
          }
          let dataApi = {};
          if (this.data_trigger.object === 'api' || this.data_trigger.object === 'api_v2') {
            dataApi = {
              method: this.data_trigger.method,
              url: this.data_trigger.url,
            };
          }
          if (this.data_trigger.object === 'api_v2') {
            dataApi.rate_limit = this.data_trigger.is_rate_limits ? Number(this.data_trigger.rate_limits) : 0;
            // dataApi.max_length_char_payload = this.data_trigger.is_max_length_limits ? Number(this.data_trigger.max_length_limits) : 0;
          }
          let dataEvent = {};
          if (this.data_trigger.object === 'event') {
            dataEvent = {
              name: this.data_trigger.event_name,
            };
          }
          let dataFunction = {};
          if (this.data_trigger.object === 'function') {
            dataFunction = {
              name: this.data_trigger.function_name,
            };
          }
          let dataJob = {};
          if (this.data_trigger.object === 'job') {
            dataJob = {
              name: this.data_trigger.job_name,
            };
          }
          let dedicatedJob = {};
          if (this.data_trigger.object === 'dedicated_job') {
            dedicatedJob = {
              name: this.data_trigger.dedicated_job_name,
            };
          }
          const data = {
            id: this.data_trigger.id,
            type: this.data_trigger.object,
            form: dataForm,
            container_variable: this.data_trigger.variable_name,
            container_response: this.data_trigger.variable_response,
            scheduler: dataSceduller,
            event: dataEvent,
            function: dataFunction,
            job: dataJob,
            dedicated_job: dedicatedJob,
          };
          const dataVP = {
            name: this.name_automation,
            description: this.description,
            disable_run_history: this.disable_run_history,
            is_active: this.disable_block,
            is_update_service: this.showSwitcherService && this.nocodeServiceOrigin !== this.nocodeServiceTarget,
            nocode_service_target: this.nocodeServiceTarget,
          };
          if (this.data_trigger.object === 'api') data.api = dataApi;
          if (this.data_trigger.object === 'api_v2') data.api_v2 = dataApi;
          if (this.data_trigger.object === 'webhook') data.webhook = dataWebhook;
          if (this.data_trigger.object === 'webhook_v2') data.webhook_v2 = dataWebhook;
          resolve({ data, dataVP });
        } else {
          reject(null);
        }
      });
    },

    showProperties() {
      if (this.propertiesOpened) {
        this.setPropertiesOpened({
          open: false,
        });

        setTimeout(() => {
          this.blockActive = true;
          this.setPropertiesOpened({
            open: true,
            type: 'trigger',
            data: this.dataEdit,
          });
        }, 100);
      } else {
        this.blockActive = true;
        this.setPropertiesOpened({
          open: true,
          type: 'trigger',
          data: this.dataEdit,
        });
      }
    },

    setErrorBlock() {
      this.blockError = true;
    },

    clearErrorBlock() {
      this.blockError = false;
    },

    copyToClipboard() {
      const el = document.createElement('textarea');
      el.value = `${this.url}${this.data_trigger.url}`;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', 'Copied to clipboard');
    },
  },
  validations() {
    return {
      data_trigger: {
        object: {
          required,
        },
        table_group: {
          required: requiredIf(() => this.data_trigger.object === 'form'),
        },
        form: {
          required: requiredIf(() => this.data_trigger.object === 'form'),
        },
        event: {
          required: requiredIf(() => this.data_trigger.object === 'form'),
        },
        event_name: {
          required: requiredIf(() => this.data_trigger.object === 'event'),
        },
        function_name: {
          required: requiredIf(() => this.data_trigger.object === 'function'),
        },
        job_name: {
          required: requiredIf(() => this.data_trigger.object === 'job'),
        },
        dedicated_job_name: {
          required: requiredIf(() => this.data_trigger.object === 'dedicated_job'),
        },
        variable_name: {
          required,
        },
        every_int: {
          required: requiredIf(() => this.data_trigger.object === 'scheduller'),
        },
        every: {
          required: requiredIf(() => this.data_trigger.object === 'scheduller'),
        },
        at: {
          required: requiredIf(() => this.data_trigger.object === 'scheduller'),
        },
        method: {
          required: requiredIf(() => this.data_trigger.object.includes('webhook') || this.data_trigger.object.includes('api')),
        },
        url: {
          required: requiredIf(() => this.data_trigger.object.includes('webhook') || this.data_trigger.object.includes('api')),
        },
        content_type: {
          // required: requiredIf(() => this.data_trigger.object === 'webhook'),
        },
        header: {
          // required: requiredIf(() => this.data_trigger.object === 'webhook'),
        },
        variable_response: {
          required: requiredIf(() => this.data_trigger.object.includes('webhook') || this.data_trigger.object.includes('api') || this.data_trigger.object === 'function'),
        },
      },
      name_automation: { required },
      description: {},
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/jVPBlockTrigger.vue